module.exports = __webpack_public_path__ + "british-indian-ocean-territory.svg?132d427f1326fd4cf994a25d7da2445b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/british-indian-ocean-territory.svg
// module id = 119
// module chunks = 10